const isDomainRebrand = window.location.hostname === process.env.APP_DOMAIN_REBRAND;

export default {
  urls: {
    KLICKART_URL: isDomainRebrand
      ? process.env.KLICKART_URL_REBRAND
      : process.env.KLICKART_URL,
    UPGRADE_USER_KLICK: process.env.UPGRADE_USER_KLICK,
    UPGRADE_USER_EXTENSION: process.env.UPGRADE_USER_EXTENSION,
    START_HERE_URL: process.env.START_HERE_URL,
    HELP_CENTER_URL: process.env.HELP_CENTER_URL,
    EMAIL_MARKETING_BRAND: process.env.EMAIL_MARKETING_BRAND,
    PAGE_MANAGER_URL: isDomainRebrand
      ? process.env.PAGE_MANAGER_URL_REBRAND
      : process.env.PAGE_MANAGER_URL,
    FREE_PLAN_MERLIN_ID: process.env.FREE_PLAN_MERLIN_ID,
    PAYED_PLAN_MERLIN_ID: process.env.PAYED_PLAN_MERLIN_ID,
    ZENDESK_MESSENGER_ID: process.env.ZENDESK_MESSENGER_ID,
    COOKIE_DOMAIN: isDomainRebrand
      ? process.env.COOKIE_DOMAIN_REBRAND
      : process.env.COOKIE_DOMAIN,
    SEND_URL: isDomainRebrand
      ? process.env.SEND_URL_REBRAND
      : process.env.SEND_URL,
  },
};



// WEBPACK FOOTER //
// ./src/config/universal-navigator/index.js